__turbopack_context__.v({
  "accordionButton": "DvCIAa_accordionButton",
  "accordionClose": "DvCIAa_accordionClose",
  "accordionOpen": "DvCIAa_accordionOpen",
  "accordionPanel": "DvCIAa_accordionPanel",
  "accordionPanelContent": "DvCIAa_accordionPanelContent",
});
